module.exports = __webpack_public_path__ + "img/BIT_white26.641fd3d2.jpg";